import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    account: null, //current account details
    withdrawals: [], //this month
    availableBalance: 0,
}

// Helper function to calculate availableBalance
const calculateAvailableBalance = (account, withdrawals) => {
    if (!account || !withdrawals) return Number(account?.balance) || 0;

    // Sum the amount of withdrawals where status is "pending"
    const pendingWithdrawals = withdrawals
        .filter(withdrawal => withdrawal.status === 'pending')
        .reduce((total, withdrawal) => total + Number(withdrawal.amount), 0);

    // Calculate available balance: account balance - pending withdrawals
    return Number(account.balance) - pendingWithdrawals;
};

export const financeSlice = createSlice({
    name: 'finance',
    initialState,
    reducers: {
        updateFinance: (state, action) => {
            state.account = action.payload.account ? action.payload.account : state.account
            state.withdrawals = action.payload.withdrawals ? action.payload.withdrawals : state.withdrawals
            state.availableBalance = calculateAvailableBalance(state.account, state.withdrawals);
            console.log('finance update to', state)
        },
        updateFinanceAccount: (state, action) => {
            state.account = action.payload
            state.availableBalance = calculateAvailableBalance(state.account, state.withdrawals);
        },
        updateFinanceWithdrawals: (state, action) => {
            console.log('saving account settings to redux')
            state.withdrawals = action.payload
            state.availableBalance = calculateAvailableBalance(state.account, state.withdrawals);
        },
        updateFinanceAvailableBalance: (state, action) => {
            console.log('saving account schedule to redux')
            state.availableBalance = action.payload
        },

        clearFinanceData: (state) => {
            console.log('clearing account')
            state.account = null
            state.withdrawals = null
            state.availableBalance = 0
        }
    }
});

export const { updateFinance,
    updateFinanceAccount,
    updateFinanceWithdrawals,
    updateFinanceAvailableBalance,
    clearFinanceData } = financeSlice.actions;

export default financeSlice.reducer